<template>
    <!-- 升学途径 (综合评价录取)-->
    <div class="comprehensive_evaluation">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner_tool.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">什么是综合评价录取</h6>
            <div class="main_box">
                <p>是指在高考改革试点省的试点高等院校录取新生时，综合考量考生高考成绩、高校考核结论、高中学业水平测试成绩、综合素质评价以及高校自身培养特色要求等五个维度的内容，对高考成绩达到一定要求的入选考生，综合评价，择优录取。浙江省统称“三位一体”。</p>
            </div>    
        </div>
        <div class="main">
            <h6 class="main_title">报名条件有哪些？</h6>
            <div class="main_box">
                <p>综合评价各校招生范围不同，招生条件也不尽相同，综合查看2019年高校综合评价招生简章发现，综合评价招生条件主要有以下几种：</p>
                <p>1.针对本省招生的高校普遍对学业水平考试成绩有相关要求。如： 中国海洋大学要求学生学业水平考试各科目等级最低要求为9A1B，且与报考专业类别相对应科目等级须为A 。</p>
                <p>2.部分院校对考生高中成绩有明确要求，如山东大学在2019年招生简章中明确提出“报考A、B类考生高中阶段历次期末考试成绩及高考模拟考试成绩原则上不低于年级前10%（文理分别排序）；报考C类考生不低于年级前30%。</p>
                <p>3.中外合作大学对学生的英语能力要求较高。</p>
                <p>4.少部分高校要求考生参加社区服务和社会实践活动等，如：山大、中海洋等高校，有此要求的大部分为山东地区高校。整体来看，高校综合评价招生条件要求不一，且对各种奖项没有严格限制，对于成绩中上等的考生，如在高校招生区域，后期简章发布后，可尝试报名。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">适合什么样的考生报考？</h6>
            <div class="main_box">
                <p>（1）文化成绩排名不是最靠前和最靠后的考生，可以考虑报考“综合评价招生”，如果你的文化成绩排名不是很靠前，但综合素质发展比较均衡，没有明显的“短腿”，不妨尝试报考一下综合评价招生。它作为独立批次，不会影响你高考的录取。</p>
                <p>（2）在高中动手能力强、有相关学科的实践经验或是有从事社会事务经验的考生，在报考中会有一些优势。相反，除了学习以外，动手能力不强，对社会关注度不高，缺乏社会基本沟通能力的考生，会在考核中处于劣势。</p>
                <p>（3）对专业认知度很高的考生，也就是说一定想读这类专业，甚至想好了毕业后也从事这个专业领域，对这类专业有特别的兴趣爱好，也有一定的专业知识积累，这类考生一定是招生首先青睐的对象。</p>
            </div>
        </div>
        <!-- <div class="main compare">
            <h6 class="main_title">与自主招生区别</h6>
            <div class="main_box">
                <div class="title_box">
                    <p>综合评价录取</p>
                    <p>自主招生</p>
                </div>
                <ul>
                    <li>
                        <p>目前在部分省市实施，每年有新的高校参与</p>
                        <p>90所，大部分为985、211高校</p>
                        <div class="arrow">实施院校</div>
                    </li>
                    <li>
                        <p>招收品学兼优、综合素质优秀的学生，更加侧重学生的综合成绩和综合素质招收品学兼优、综合素质优秀的学生，更加侧重学生的综合成绩和综合素质</p>
                        <p>具有学科特长和创新潜质的学生，多为竞赛生</p>
                        <div class="arrow">招生对象</div>
                    </li>
                    <li>
                        <p>一般对竞赛奖项没有特别硬性的要求，相对自招更加容易</p>
                        <p>多要求有竞赛奖项，大部分要求五大学科竞赛省一及以上的奖项或者是科创类的奖项，对学生要求较高</p>
                        <div class="arrow">报名条件</div>
                    </li>
                    <li>
                        <p>高考成绩、高校综合测试成绩、高中学业水平测试成绩三者按比例（一般为6:3:1）计算综合成绩，最后进行录取</p>
                        <p>给予降分录取优惠，2019年降分幅度较小</p>
                        <div class="arrow">优惠政策</div>
                    </li>
                </ul>
            </div>
        </div> -->
        <div class="remind main">
            <h6 class="main_title">特别提醒</h6>
            <div class="main_box">
                <p><span>1</span>“综合评价”从2015年开始实施，随着清华、北大、北外等一批高校的陆续加入，高校阵容不断壮大。</p>
                <!-- <p><span>2</span>相比自招对国奖、省奖等多种含金量大奖的明确要求，综评只要你高中学习成绩优秀就能报名，而且初审通过率远远高于自主招生。</p> -->
                <p><span>2</span>大多数进行综合评价录取的高校都在阳光高考综合评价报名页面网址（http://bm.chsi.com.cn/）里报名。少数学校比如：中国科学院大学、南方科技大学、上海科技大学、中南大学(分数线,专业设置)等是在本校本科招生网站上报名。</p>
                <p><span>3</span>并不是所有的高校都具有综合评价招生资格，某些具有综合评价招生资格的高校并不是面对全国来招生的。</p>
                <p><span>4</span>考生和家长一定要仔细阅读学校的招生简章，一个学校的招生人数、报考条件以及考试科目、优惠政策都在简章中，是非常重要的参考。</p>
            </div>   
        </div>
        <div class="universities main">
            <h6 class="main_title">
                综合评价试点高校 
                <span>*由于试点高校陆续更新，请各位考生以考试院/高校公布的消息为准</span>
            </h6> 
            <div class="school_box"  v-for="(item, index) in zongheSchool" :key="index">
                <p class="school_title">{{item.title}}</p>
                <ul>
                    <li v-for="(school, index) in item.schoolName" :key="index" @click="goUniversity(school)">{{school}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },  
    // props: [ 'message' ],
     data() {
        return {
            zongheSchool: [ 
                { title: '面向多地区招生', schoolName:  ["北京大学", "清华大学", "北京外国语大学（22省市)", "中国科学院大学（7省市）", "南方科技大学（22省市）", "上海科技大学（17省市）", "深圳北理莫斯科大学（14省市）", "昆山杜克大学（18省市", "上海纽约大学"]},


                { title: '面向浙江（三位一体）招生的高校', schoolName: ["浙江大学", "清华大学", "北京大学", "复旦大学", "上海交通大学", "中国科学院大学", "中国科学技术大学", "香港中文大学（深圳）", "南方科技大学", '中国美术学院','浙江工业大学','浙江师范大学','宁波大学','杭州电子科技大学','浙江工商大学','温州医科大学','浙江海洋大学','浙江农林大学','浙江中医药大学','中国计量大学','浙江万里学院','浙江科技学院','浙江财经大学','嘉兴学院','杭州师范大学','湖州师范学院','绍兴文理学院','台州学院','温州大学','浙江外国语学院','宁波工程学院','衢州学院','浙江水利水电学院','浙江警察学院','杭州医学院','丽水学院','温州肯恩大学','宁波诺丁汉大学','浙江音乐学院','浙江大学城市学院','浙江大学宁波理工学院','浙江树人学院','浙江越秀外国语学院','宁波财经学院','浙江工业大学之江学院','宁波大学科学技术学院','杭州电子科技大学信息工程学院','温州医科大学仁济学院','浙江中医药大学滨江学院','中国计量大学现代科技学院','浙江财经大学东方学院','杭州师范大学钱江学院','绍兴文理学院元培学院','温州大学瓯江学院','温州商学院','同济大学浙江学院','上海财经大学浙江学院','金华职业技术学院'] },

                { title: '面向上海招生的高校', schoolName: ["复旦大学", "上海交通大学", "同济大学", "华东师范大学", "华东理工大学", "上海外国语大学", "上海财经大学", "上海大学", "东华大学", "上海中医药大学", "浙江大学"] },

                
                { title: '面向山东省招生的院校', schoolName: ["山东大学", "中国海洋大学", "中国石油大学（华东）", "哈尔滨工业大学（威海）", "青岛大学", "山东师范大学", "山东科技大学", "青岛科技大学", "山东财经大学", "浙江大学"]},

                { title: '面向江苏省招生的院校', schoolName: ["南京大学", "东南大学", "中国科学院大学", "北京外国语大学", "上海科技大学", "南方科技大学", "上海纽约大学", "昆山杜克大学", "香港中文大学（深圳）", '南京师范大学','南京信息工程大学','南京工业大学','南京邮电大学','南京医科大学','南京中医药大学','南京林业大学','江苏师范大学','南通大学','扬州大学','江苏大学','西交利物浦大学'] },

                { title: '面向广东省招生的院校', schoolName: ["北京外国语大学", "南方科技大学", "西交利物浦大学", "上海纽约大学", "昆山杜克大学", "深圳北理莫斯科大学", "北京师范大学-香港浸会大学联合国际学院"] },
                
                { title: '面向辽宁省、湖南省、云南省招生的高校', schoolName: ["东北大学（辽宁）", "中南大学（湖南）", "中南大学（云南）"]},
            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: '院校详情',
                query: {
                    id: id,
                }
            })
            // window.open(href, '_blank');
             this.$router.push('/explore/yuanxiaoxiangqing?id='+id)
        }
    },
    created() {
        
    }
}
</script>
<style type="text/css" lang='less' scoped>
.comprehensive_evaluation {
    box-sizing: border-box;
    width: 970px;
    background-color: #fff;
    padding: 20px;
    .banner {
        width: 100%;
        // height: 212px;
    }
    .main {
        padding-top: 40px;
    }
    .main_title {
        line-height: 40px;
        text-align: left;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 20px;
        padding-left: 40px;
        background: url(/imgs/wayToStudy/common/icon_title.png) no-repeat 0px center;
    }
    .main_box {
        p {
            line-height: 30px;
            font-size: 14px;
            color: #666;
            margin-bottom: 10px;
        }
    }   
    .zizhaoliucheng {
        ul {
            display: flex;
            li {
                flex: 1;

            }
        }
    }
    .remind {
        .main_box {
            p {
                span {
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    border-radius: 50%;
                    background-color: #2c8ffc;
                    color: #fff;
                    vertical-align: middle;
                    margin-right: 6px;
                    font-size: 12px;
                }
            }
        }

    }
    .universities {
        .main_title {
            span {
                font-size: 14px;
                color: red;
            }
        }
        .school_title {
            background: #60badf;
            color: #fff;
            line-height: 50px;
            text-align: center;
            border: 1px solid #60badf;
        }
        .province_school {
            text-align: center;
            line-height: 50px;
            font-size: 16px;
            border-bottom: 1px solid #eaeaea;
        }
        ul {
            overflow: hidden;
            width: 933px;
            li {
                font-size: 14px;
                box-sizing: border-box;
                float: left;
                width: 25%;
                border: 1px solid #eaeaea;
                margin-left: -1px;
                margin-top: -1px;
                min-height: 42px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 20px;
                text-align: center;
                &:nth-child(4n+1) {
                    margin-left: 0px;
                }
                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }
                &:nth-child(8n-1),&:nth-child(8n-2),&:nth-child(8n-3),&:nth-child(8n) {
                    background-color: #e6f8ff;
                }
            }
        }
    }
    .compare {
        .title_box {
            display: flex;
            p {
                width: 50%;
                line-height: 40px;
                font-weight: 600;
                font-size: 20px;
                text-align: center;
                &:first-child {
                    color: #2c7ffc;
                }
                &:last-child {
                    color: #f9aa11;
                }
            }
        }
        ul {
            li {    
                display: flex;
                justify-content: space-between;
                margin-bottom: 40px;
                position: relative;
                .arrow {
                    width: 90px;
                    height: 90px;
                    text-align: center;
                    line-height: 90px;
                    background-color: #60badf;
                    color: #fff;
                    // border: 1px solid #60badf;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin-top: -45px;
                    margin-left: -45px;
                    border-radius: 50%;
                }
                p {
                    width: 42%;
                    line-height: 24px;
                    padding: 10px 20px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 0px;
                    border-radius: 5px;
                    &:first-child {
                        border: 1px solid #2c7ffc;
                        color: #2c7ffc;
                    }
                    &:nth-child(2) {
                        border: 1px solid #f9aa11;
                        color: #f9aa11;
                    }

                }
            }
        }
    }
}
</style>